import * as React from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { getStore } from "bundles/BigqueryQueryViewer/store";
import I18n from "lib/I18n";
import { observer } from "mobx-react-lite";

export const ChatPreferencesModal = observer(() => {
  const store = getStore().chat;
  const isDisabled =
    store.isPreferencesLoading ||
    store.isPreferencesSaving ||
    store.hasPreferencesLoadError;

  return (
    <Modal
      show={store.isPreferencesOpen}
      onHide={() => store.closePreferences()}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {I18n.t("bigquery_query_viewer.label.chat_preferences")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {store.hasPreferencesError && (
          <div className="alert alert-danger" role="alert">
            {I18n.t("bigquery_query_viewer.messages.chat_preferences_error")}
          </div>
        )}
        <Form.Group className="mb-3">
          <Form.Label>
            {I18n.t("bigquery_query_viewer.label.user_instruction")}
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={5}
            placeholder={I18n.t(
              "bigquery_query_viewer.label.user_instruction_placeholder",
            )}
            value={store.chatPreferences.userInstruction}
            onChange={(event) =>
              (store.chatPreferences.userInstruction =
                event.currentTarget.value)
            }
            disabled={isDisabled}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>
            {I18n.t("bigquery_query_viewer.label.title_user_instruction")}
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={5}
            placeholder={I18n.t(
              "bigquery_query_viewer.label.title_user_instruction_placeholder",
            )}
            value={store.chatPreferences.titleUserInstruction}
            onChange={(event) =>
              (store.chatPreferences.titleUserInstruction =
                event.currentTarget.value)
            }
            disabled={isDisabled}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="light"
          onClick={() => store.closePreferences()}
          disabled={store.isPreferencesSaving}
        >
          {I18n.t("bigquery_query_viewer.label.cancel")}
        </Button>
        <Button
          variant="primary"
          onClick={() => store.savePreferences()}
          disabled={isDisabled}
        >
          {I18n.t("bigquery_query_viewer.label.save")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
});
